<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BAuuwy/tc-custom/9781399098533.jpg?1709609084044" alt="This image is the cover for the book Roman Legends Brought to Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Roman Legends Brought to Life
      </h1>
      <p class="bookDescription body article font2">
        <p>The legends of early Rome are among the most memorable of any in the world. They are also highly instructive. They taught generations of Romans about duty and obedience. Duty and obedience might not seem to amount to much these days, but it was precisely these virtues that made Rome great. The legends are not, however, merely self-congratulatory and they are rarely simple exercises in nationalist propaganda. On the contrary, many reveal their ancestors’ dark side, which they expose unflinchingly.  As in the case of Greek mythology, there is no authorised version of any Roman legend. The legends survived because they reminded the Romans who they were, what modest beginnings they came from, how on many occasions their city nearly imploded, and what type of men and women shaped their story.  Defeat, loss, failure. That’s where this story – the story of the boldest, most enduring, and most successful political experiment in human history – begins. It’s the story of how a band of refugees escaped from the ruins of a burning city and came to establish themselves hundreds of miles to the west in the land of Hesperia, the Western Land, the land where the sun declines, aka Italia. It’s the story of a people who by intermingling, compromise and sheer doggedness came to dominate first their region, then the whole of peninsula Italy, and finally the entire Mediterranean and beyond.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Garland
      </h2>
      
      <p class="authorDescription body article">Robert Garland is the Roy D. and Margaret B. Wooster Professor of the Classics at Colgate University, where he has taught for 30 years. He attended drama school before completing his Ph.D. at University College London. In recent years he has recorded four courses for The Great Courses and written two videos for TED Animation. Robert has published 13 academic books on both Greek and Roman history, and has recently finished a comic historical novel. His interest is in how to make history come alive and his most important contribution to the discipline has been to identify categories of people who have been generally overlooked in conventional accounts of ancient history, including the disabled and refugees.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f5f3e9c8